import React, { useState } from 'react';
import MainLayout from '../components/templates/MainLayout';
import Hero from '../components/organisms/Hero';
import DifferenceSection from '../components/organisms/DifferenceSection';
import ServicesSection from '../components/organisms/ServicesSection';
import BeforeAfterSection from '../components/organisms/BeforeAfterSection';
import ReviewsSection from '../components/organisms/ReviewsSection';
import GallerySection from '../components/organisms/GallerySection';
import BookingSection from '../components/organisms/BookingSection';
import NewsletterSection from '../components/organisms/NewsletterSection';

const HomePage = () => {
    const [selectedService, setSelectedService] = useState('The Minimalist');

    return (
        <MainLayout>
            <Hero />
            <DifferenceSection />
            <ServicesSection setSelectedService={setSelectedService} />
            <BeforeAfterSection />
            <ReviewsSection />
            <GallerySection />
            <BookingSection selectedService={selectedService} />
            <NewsletterSection />
        </MainLayout>
    );
};

export default HomePage;
